/**
 * /tenants/$slug/agents/grants — Active grants (AI Agents → Agent governance).
 * Tenant-wide live-grant oversight, moved off the registry list page (§5b).
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchGrants } from "@/features/agents/queries";
import { queryKeys } from "@/lib/query-keys";
import { AgentGrantsPage } from "@/features/agents/pages/agent-grants-page";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/grants")({
  // Prefetch the default (active-only) grants view so the table is warm on
  // navigation, matching the sibling agent routes' loader idiom.
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.agents.grants(context.tenant.id, false),
      queryFn: () => fetchGrants(context.tenant.id, false),
    }),
  component: AgentGrantsPage,
});
